import { ManagementStylesDTO } from '../../../api/useOtherAssetsQuery';

export const EXCLUDE_OPT = {
  label: 'Exclude from Asset Bucketing',
  value: -1,
};

interface GetCustomBucketIndexParams {
  assetBucketingByManagementStyle: boolean;
  customBucketIndex: number | null;
  isExcludedFromAssetBucketing: boolean;
  managementStyles: ManagementStylesDTO[];
  orionManagementStyleId: number | null;
}

export const getCustomBucketIndex = ({
  isExcludedFromAssetBucketing,
  assetBucketingByManagementStyle,
  customBucketIndex,
  managementStyles,
  orionManagementStyleId,
}: GetCustomBucketIndexParams) => {
  if (assetBucketingByManagementStyle) {
    const selectedManagementStyle = managementStyles.find(
      option => option.id === orionManagementStyleId,
    );

    if (!selectedManagementStyle) {
      return null;
    }

    if (customBucketIndex !== null) {
      return customBucketIndex === EXCLUDE_OPT.value ? EXCLUDE_OPT.value : customBucketIndex;
    }

    const isExclude = selectedManagementStyle.defaultBucket === null;

    return isExclude ? EXCLUDE_OPT.value : selectedManagementStyle.defaultBucket;
  }

  return isExcludedFromAssetBucketing ? EXCLUDE_OPT.value : customBucketIndex;
};

interface GetAssetBucketOptionsParams {
  assetBucketOptions: { label: string; value: number }[] | null;
  assetBucketingByManagementStyle: boolean;
  managementStyleSelection: number | null;
  managementStylesOptions: { label: string; value: number; defaultBucketIndex: number | null }[];
}

export const getAssetBucketOptions = ({
  assetBucketOptions,
  assetBucketingByManagementStyle,
  managementStyleSelection,
  managementStylesOptions,
}: GetAssetBucketOptionsParams) => {
  if (!assetBucketOptions) {
    return null;
  }

  return assetBucketOptions.map(assetBucketOption => {
    if (assetBucketingByManagementStyle) {
      if (managementStyleSelection !== null) {
        const assetBucketIndex = managementStylesOptions.find(
          option => option.value === managementStyleSelection,
        );

        const isExclude = assetBucketIndex?.defaultBucketIndex === null;

        const selectedManagementStyle = isExclude
          ? EXCLUDE_OPT.value
          : assetBucketIndex?.defaultBucketIndex;

        return {
          ...assetBucketOption,
          rightLabel: assetBucketOption.value === selectedManagementStyle ? 'Default' : undefined,
        };
      }
    }

    return assetBucketOption;
  });
};
